export const pattern = {
  noSpace: /^\S*$/,
  name: /^[a-zA-Z]+$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  email: /^[a-zA-Z0-9._%+-]+@(alliantgroup\.com|harshbergerenterprises\.com)$/,
};